import { PluginType, type IExportPlugin } from '@/version-types';
import { VectorLayerSVGPreviewPlugin } from './manager';
import { VectorLayerSVGPreview } from './view';

export const vectorLayerSVGPreviewPlugin: IExportPlugin = {
    sort: 10,
    type: PluginType.STAGE,
    name: 'vector-layer-svg-preview',
    render: () => <VectorLayerSVGPreview />,

    createInstance: ({ identity }) => {
        return [{ key: 'VectorLayerSVGPreviewPlugin', value: new VectorLayerSVGPreviewPlugin(identity) }];
    },

    destroy: ({ getInstance }) => {
        getInstance<VectorLayerSVGPreviewPlugin>('VectorLayerSVGPreviewPlugin').dispose();
    },
};
